export { ForecastPage as default } from '@/components/pages/Ir/Financial/Forecast'
